<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="2">
          <el-step title="空运信息"></el-step>
          <el-step title="增值服务"></el-step>
          <el-step title="托运信息"></el-step>
          <el-step title="确认委托"></el-step>
          <el-step title="委托完成"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <div
          style="display: flex; display: -webkit-flex; align-items: center"
        ></div>
        <!-- 委托信息 -->
        <div class="Item_list">
          <div
            style="
              display: flex;
              display: -webkit-flex;
              align-items: center;
              margin-bottom: 20px;
            "
          >
            <img src="../../assets/weituo.png" alt="" />
            <p class="tittype">委托信息</p>
          </div>
          <el-row :gutter="20">
            <el-form :label-position="labelPosition" label-width="70px">
              <el-col :span="10">
                <el-form-item label="联系人">
                  <el-input
                    disabled
                    v-model="Authorization.customerContact"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="联系电话">
                  <el-input
                    disabled
                    v-model="Authorization.customerTel"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="委托公司">
                  <el-input disabled v-model="Authorization.namec"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="10">
                <el-form-item label="业务员">
                  <el-input
                    disabled
                    v-model="Authorization.salesName"
                  ></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="10" v-if="pickFeeForAir.pickUpdate">
                <el-form-item label="提货时间">
                  <el-date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    disabled
                    placeholder="选择日期"
                    v-model="pickFeeForAir.pickUpdate"
                    style="width: 100%"
                    :picker-options="pickerOptions"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10" v-if="!pickFeeForAir.checked">
                <el-form-item label="入仓时间">
                  <el-date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    v-model="inwarehousetime"
                    style="width: 100%"
                    :picker-options="pickerSetTime"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
        <!-- 提货信息 -->
        <div class="Item_list" style="" v-show="pickFeeForAir.checked">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/tihuo.png" alt="" />
              <p class="tittype" style="color: #333">提货信息</p>
            </div>
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <!-- 当前展示的联系人 -->
            <div
              class="thatpoperWrap"
              v-show="pickFeeForAir.name"
              style="margin-top: 20px"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ pickFeeForAir.name }}</p>
                <p style="margin-left: 12px">{{ pickFeeForAir.tel }}</p>
                <p class="overText" style="margin-left: 20px">
                  {{ pickFeeForAir.parvince }}{{ pickFeeForAir.city
                  }}{{ pickFeeForAir.area }}{{ pickFeeForAir.address }}
                </p>
              </div>
            </div>
            <el-collapse-transition>
              <div v-show="!pickFeeForAir.checked">
                <div
                  class="poperWrap"
                  style="margin-top: 20px"
                  v-for="(item, index) in TipopList"
                  :key="index"
                  @click="changeTiitem(item)"
                >
                  <div class="popWrap_l">
                    <p class="lianxiren">{{ item.name }}</p>
                    <p style="margin-left: 12px">{{ item.tel }}</p>
                    <p class="overText" style="margin-left: 20px">
                      {{ item.parvince }}{{ item.city }}{{ item.area
                      }}{{ item.address }}
                    </p>
                  </div>
                  <div class="popWrap_R">
                    <span class="morentype" v-show="item.isdefault"
                      >默认地址</span
                    >
                    <el-button
                      v-show="!item.isdefault"
                      style="color: #604aff"
                      type="text"
                      @click.stop="changeshowType(2, item, 'ajax')"
                      >设为默认地址</el-button
                    >
                    <el-button
                      style="color: #604aff"
                      type="text"
                      @click.stop="UpItem(2, item)"
                      >修改</el-button
                    >
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div
            style="margin: 10px 0 0 30px"
            v-show="TipopList.length > 1 && !pickFeeForAir.checked"
          >
            <el-button
              @click="showTi = !showTi"
              style="color: #9a9a9a"
              type="text"
              >{{ showTi ? "收起更多" : "更多提货人信息" }}</el-button
            ><span
              :class="showTi ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></span>
          </div>
        </div>
        <!-- 收货信息地址 -->
        <div class="Item_list">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/shouhuo.png" alt="" />
              <p class="tittype">收货信息</p>
            </div>
            <span v-if="!sendFeeForAir.checked" style="float: right"
              ><el-button
                @click="addNewpop(3)"
                type="text"
                style="color: #604aff"
                >新增收货人</el-button
              ></span
            >
          </div>
          <!-- 如果选了派送就不显示修改 -->
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <div class="poperWrap" v-show="!sendFeeForAir.name">
              暂无默认联系人请添加
            </div>
            <!-- 当前展示的联系人 -->
            <div
              class="thatpoperWrap"
              v-show="sendFeeForAir.name"
              style="margin-top: 20px"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ sendFeeForAir.name }}</p>
                <p style="margin-left: 12px">{{ sendFeeForAir.tel }}</p>
                <p class="overText" style="margin-left: 20px">
                  {{ sendFeeForAir.country }}{{ sendFeeForAir.city
                  }}{{ sendFeeForAir.area }}{{ sendFeeForAir.address }}
                </p>
              </div>
              <div class="popWrap_R" v-if="!sendFeeForAir.checked">
                <span class="morentype" v-show="sendFeeForAir.isdefault"
                  >默认地址</span
                >
                <el-button
                  v-show="!sendFeeForAir.isdefault"
                  style="color: #604aff"
                  type="text"
                  @click.stop="changeshowType(3, sendFeeForAir, 'loca')"
                  >设为默认地址</el-button
                >
                <el-button
                  style="color: #604aff"
                  type="text"
                  @click.stop="UpItem(3, sendFeeForAir)"
                  >修改</el-button
                >
              </div>
            </div>

            <el-collapse-transition>
              <div v-show="showReceive">
                <div
                  class="poperWrap"
                  style="margin-top: 20px"
                  v-for="(item, index) in SHpopList"
                  :key="index"
                  @click="changeShitem(item)"
                >
                  <div class="popWrap_l">
                    <p class="lianxiren">{{ item.name }}</p>
                    <p style="margin-left: 12px">{{ item.tel }}</p>
                    <p class="overText" style="margin-left: 20px">
                      {{ item.country }}{{ item.city }}{{ item.area
                      }}{{ item.address }}
                    </p>
                  </div>
                  <div class="popWrap_R">
                    <span class="morentype" v-show="item.isdefault"
                      >默认地址</span
                    >
                    <el-button
                      v-show="!item.isdefault"
                      style="color: #604aff"
                      type="text"
                      @click.stop="changeshowType(3, item, 'ajax')"
                      >设为默认地址</el-button
                    >
                    <el-button
                      style="color: #604aff"
                      type="text"
                      @click.stop="UpItem(3, item)"
                      >修改</el-button
                    >
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div
            style="margin: 10px 0 0 30px"
            v-show="SHpopList.length > 1 && !sendFeeForAir.checked"
          >
            <el-button
              @click="showReceive = !showReceive"
              style="color: #9a9a9a"
              type="text"
              >{{ showReceive ? "收起更多" : "更多收货人信息" }}</el-button
            ><span
              :class="showReceive ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></span>
          </div>
        </div>
        <!-- 发货信息地址 ，发货人始终可修改-->
        <div class="Item_list">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/fahuo.png" alt="" />
              <p class="tittype">发货信息</p>
            </div>
            <span style="float: right"
              ><el-button
                @click="addNewpop(1)"
                type="text"
                style="color: #604aff"
                >新增发货人</el-button
              ></span
            >
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <div class="poperWrap" v-show="countLIst_S.name == ''">
              暂无默认联系人请添加
            </div>
            <div
              class="thatpoperWrap"
              v-show="countLIst_S.name"
              style="margin-top: 20px"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ countLIst_S.name }}</p>
                <p style="margin-left: 12px">{{ countLIst_S.tel }}</p>
              </div>
              <div class="popWrap_R">
                <span class="morentype" v-show="countLIst_S.isdefault"
                  >默认地址</span
                >
                <el-button
                  v-show="!countLIst_S.isdefault"
                  style="color: #604aff"
                  type="text"
                  @click.stop="changeshowType(1, countLIst_S, 'loca')"
                  >设为默认地址</el-button
                >
                <el-button
                  style="color: #604aff"
                  type="text"
                  @click="UpItem(1, countLIst_S)"
                  >修改</el-button
                >
              </div>
            </div>
            <el-collapse-transition>
              <div v-show="showFa">
                <div
                  class="poperWrap"
                  style="margin-top: 20px"
                  v-for="(item, index) in FapopList"
                  :key="index"
                  @click="changeFAitem(item)"
                >
                  <div class="popWrap_l">
                    <p class="lianxiren">{{ item.name }}</p>
                    <p style="margin-left: 12px">{{ item.tel }}</p>
                  </div>
                  <div class="popWrap_R">
                    <span class="morentype" v-show="item.isdefault"
                      >默认地址</span
                    >
                    <el-button
                      v-show="!item.isdefault"
                      style="color: #604aff"
                      type="text"
                      @click.stop="changeshowType(1, item, 'ajax')"
                      >设为默认地址</el-button
                    >
                    <el-button
                      style="color: #604aff"
                      type="text"
                      @click.stop="UpItem(1, item)"
                      >修改</el-button
                    >
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
          <div style="margin: 10px 0 0 30px" v-show="FapopList.length > 1">
            <el-button
              @click="showFa = !showFa"
              style="color: #9a9a9a"
              type="text"
              >{{ showFa ? "收起更多" : "更多发货人信息" }}</el-button
            ><span
              :class="showFa ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></span>
          </div>
        </div>
        <!-- 请将货物送至以下仓库 -->
        <div class="Item_list" style="padding: 0" v-if="!pickFeeForAir.checked">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div
              class=""
              style="width: 100%; background: #ffe9c7; padding: 8px 30px"
            >
              <p
                class="tittype"
                style="padding: 0 5px; color: #c19822; font-size: 16px"
              >
                请将货物送至以下仓库
              </p>
            </div>
          </div>
          <div style="width: 100%; box-sizing: border-box">
            <div
              class="thatpoperWrap"
              style="padding: 30px 50px; border: none; background: #ffffff"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ cangkuitem.namec }}</p>
                <p style="margin-left: 12px">{{ cangkuitem.tel }}</p>
                <p class="" style="margin-left: 20px">
                  {{ cangkuitem.country }}{{ cangkuitem.addressc }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 请到以下目的地仓库提取货物 -->
        <div class="Item_list" style="padding: 0" v-if="!sendFeeForAir.checked">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div
              class=""
              style="width: 100%; background: #ffe9c7; padding: 8px 30px"
            >
              <p
                class="tittype"
                style="padding: 0 5px; color: #c19822; font-size: 16px"
              >
                请到以下目的地仓库提取货物
              </p>
            </div>
          </div>
          <div style="width: 100%; box-sizing: border-box">
            <div
              class="thatpoperWrap"
              style="padding: 30px 50px; border: none; background: #ffffff"
            >
              <div class="popWrap_l">
                <p class="lianxiren">{{ description.namec }}</p>
                <p style="margin-left: 12px">{{ description.tel }}</p>
                <p class="" style="margin-left: 20px">
                  {{ description.country }}{{ description.addressc }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 备注item -->
        <div class="Item_list">
          <div
            class="LR_center"
            style="display: flex; display: -webkit-flex; align-items: center"
          >
            <div class="count_center">
              <img src="../../assets/ps.png" alt="" />
              <p class="tittype">备注</p>
            </div>
          </div>
          <div style="width: 100%; padding-left: 30px; box-sizing: border-box">
            <!-- 当前展示的联系人 -->
            <div style="margin-top: 20px">
              <div class="popWrap_l">
                <el-form style="width: 100%" ref="form" label-width="80px">
                  <el-form-item label="发货备注">
                    <el-input
                      style="width: 100%"
                      v-model="remarks.remarkForSend"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收货备注">
                    <el-input v-model="remarks.remarkForReceive"></el-input>
                  </el-form-item>
                  <el-form-item v-if="pickFeeForAir.checked" label="提货备注">
                    <el-input v-model="remarks.remarkForPick"></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <!-- item结束 -->
      </div>

      <feeDetail
        :auto_fixed="auto_fixed"
        :allMoreFeeInfo="allMoreFeeInfo"
        :transportFeeForAir="transportFeeForAir"
        :pickFeeForAir="pickFeeForAir"
        :sendFeeForAir="sendFeeForAir"
        :currencyCollection="currencyCollection"
        :calculatePrice="calculatePrice"
        :feeList="feeList"
        @pathToback="pathToback"
        @pathToNext="pathToNext"
      ></feeDetail>
      <!-- 修改地址 -->
      <el-dialog
        class="dialog"
        :width="width"
        :visible.sync="dialogTableVisible"
        :closeOnClickModal="false"
      >
        <div class="wrap_count">
          <div class="header_logo">
            {{ !this.itemid ? "新增地址" : "修改地址" }}
          </div>
          <div class="count">
            <el-form :label-position="labelPosition" label-width="80px">
              <el-form-item label="联系人">
                <el-input
                  placeholder="请输入姓名"
                  v-model="fromPop.name"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系方式">
                <el-input
                  placeholder="请输入联系方式"
                  v-model="fromPop.tel"
                ></el-input>
              </el-form-item>
              <!-- 国内省市区 -->
              <el-form-item label="联系地址" v-show="changeNum == 2">
                <el-cascader
                  style="width: 100%"
                  ref="refSsqname"
                  :options="Guojialist"
                  v-model="ssqnames"
                  @change="changessq"
                  :props="defaultParams"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.namec }}</span>
                    <span v-if="!node.isLeaf"></span>
                  </template>
                </el-cascader>
              </el-form-item>
              <!-- 国外区域 -->
              <el-form-item label="联系地址" v-show="changeNum == 3">
                <el-cascader
                  style="width: 100%"
                  ref="refSsqname"
                  :options="citylist"
                  v-model="ssqnames"
                  @change="changessq"
                  :props="defaultParams"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.namec }}</span>
                    <span v-if="!node.isLeaf"></span>
                  </template>
                </el-cascader>
              </el-form-item>
              <el-form-item v-show="changeNum != 1">
                <el-input
                  placeholder="请输入详细地址"
                  type="textarea"
                  v-model="fromPop.address"
                ></el-input>
              </el-form-item>
              <el-form-item prop="type">
                <el-checkbox-group v-model="fromPop.isdefault">
                  <el-checkbox name="type">设置为默认地址</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">{{
                  itemid ? "修改" : "确定新增"
                }}</el-button>
                <el-button @click="dialogTableVisible = false">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import feeDetail from "./component/fee-detail.vue";
export default {
  components: {
    feeDetail,
  },
  data() {
    return {
      feeList:[],
      remarks: {
        remarkForSend: "",
        remarkForReceive: "",
        remarkForPick: "",
      },
      showReceive: false,
      Authorization: JSON.parse(localStorage.getItem("Authorization")),
      allMoreFeeInfo: {
        amount: 0,
        totalExpense: "0",
        feeItemDTOS: [],
      },
      transportFeeForAir: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      sendFeeForAir: {
        checked: false,
        name: "",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      pickFeeForAir: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        pickUpdate: "",
      },
      auto_fixed: false,

      cangkuitem: null,
      // jackend
      getgoodsremarks: "",
      recgoodremarks: "",
      delgoodsremarks: "",
      inwarehousetime: "",
      description: JSON.parse(localStorage.getItem("PScangkuitem")),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerSetTime: {
        disabledDate(time) {
          if (localStorage.getItem("todoorTime")) {
            return time.getTime() < Date.now();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      //发货
      countLIst_S: {
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
      },
      //提货
      countLIst_T: {
        address: "",
        city: "",
        country: "",
        customerid: "",
        id: "",
        isdefault: false,
        name: "",
        tag: "",
        tel: "",
        parvince: "",
        area: "",
      },

      itemid: "",
      changeNum: null, //1 发货 2提货3收货
      ssqnames: [],
      citylist: [],
      Guojialist: [],
      defaultParams: {
        //定义 联级选择器的 -省市区-和-收货地址-需获取name
        label: "namec",
        value: "namec",
        children: "children",
      },
      fromPop: {
        address: "",
        parvince: "",
        city: "",
        area: "",
        country: "",
        customerid: null,
        id: "",
        isdefault: true,
        name: "",
        tag: "",
        tel: "",
      },
      isdefault: true,
      labelPosition: "left",
      dialogTableVisible: false,
      width: "420px",
      showFa: false,
      showTi: false,
      FapopList: [],
      TipopList: [],
      SHpopList: [],
      labelPosition: "left",
    };
  },
  watch: {},
  computed: {
    //折合人民币
    calculatePrice() {
      let Totalmoney = 0; //总费用
      let sendFeeForAir = 0; //配送费
      let transportFeeForAir = 0; //海运费
      let THFmoney = 0; //提货费
      transportFeeForAir = this.transportFeeForAir.cnyamount
        ? this.transportFeeForAir.cnyamount
        : 0;
      if (this.sendFeeForAir.checked) {
        //如果有配送费
        sendFeeForAir = this.sendFeeForAir.cnyprice
          ? this.sendFeeForAir.cnyprice
          : 0;
      }
      if (this.pickFeeForAir.checked) {
        //如果有提货费
        THFmoney = this.pickFeeForAir.cnyamount
          ? this.pickFeeForAir.cnyamount
          : 0;
      }

      if (transportFeeForAir) {
        Totalmoney += parseFloat(transportFeeForAir);
      }
      if (sendFeeForAir) {
        Totalmoney += parseFloat(sendFeeForAir);
      }
      if (THFmoney) {
        Totalmoney += parseFloat(THFmoney);
      }
      // 增值服务
      if (this.allMoreFeeInfo.amount > 0) {
        Totalmoney += parseFloat(this.allMoreFeeInfo.amount);
      }

      return Totalmoney.toFixed(2);
    },
    // 获得全部费用的币种
    currencyCollection() {
      let currencyAllIn = {};
      // 提货
      if (this.pickFeeForAir.currency && this.pickFeeForAir.checked) {
        if (currencyAllIn[this.pickFeeForAir.currency] === undefined) {
          currencyAllIn[this.pickFeeForAir.currency] = 0;
          currencyAllIn[this.pickFeeForAir.currency] += parseFloat(
            this.pickFeeForAir.amount
          );
        } else {
          currencyAllIn[this.pickFeeForAir.currency] += parseFloat(
            this.pickFeeForAir.amount
          );
        }
      }
      // 发货
      if (this.sendFeeForAir.currency && this.sendFeeForAir.checked) {
        if (currencyAllIn[this.sendFeeForAir.currency] === undefined) {
          currencyAllIn[this.sendFeeForAir.currency] = 0;
          currencyAllIn[this.sendFeeForAir.currency] += parseFloat(
            this.sendFeeForAir.amount
          );
        } else {
          currencyAllIn[this.sendFeeForAir.currency] += parseFloat(
            this.sendFeeForAir.amount
          );
        }
      }

      // 运费

      if (this.transportFeeForAir.currency) {
        if (currencyAllIn[this.transportFeeForAir.currency] === undefined) {
          currencyAllIn[this.transportFeeForAir.currency] = 0;
          currencyAllIn[this.transportFeeForAir.currency] += parseFloat(
            this.transportFeeForAir.amount
          );
        } else {
          currencyAllIn[this.transportFeeForAir.currency] += parseFloat(
            this.transportFeeForAir.amount
          );
        }
      }

      // 模拟增值服务
      // let temp = [
      //   { amount: 12, currency: "USD" },
      //   { amount: 32, currency: "USD" },
      //   { amount: 32, currency: "HKD" },
      //   { amount: 32, currency: "HKD" },
      // ];

      let temp = this.allMoreFeeInfo.feeItemDTOS;
      temp.forEach((item, index) => {
        if (item.checked) {
          if (currencyAllIn[item.currency] === undefined) {
            currencyAllIn[item.currency] = 0;
            currencyAllIn[item.currency] += item.amount;
          } else {
            currencyAllIn[item.currency] += item.amount;
          }
        }
      });

      let text = "";
      Object.keys(currencyAllIn).forEach((item) => {
        text += item + currencyAllIn[item].toFixed(2) + " + ";
      });

      return text.substring(0, text.length - 2);
    },
  },
  methods: {
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    changeshowType(num, item, type) {
      console.log(num);
      //设为默认
      this.axios
        .post(
          `/customer/updateAddressDefault?${qs.stringify({
            addressId: item.id,
          })}`
        )
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            num == 1
              ? this.getFadata()
              : num == 2
              ? this.getTidata()
              : this.getSHdata();
            this.$message({ message: "成功", type: "success" });
          } else {
            this.$message(res.data.message);
          }
        });
      if (num == 1 && type == "loca") {
        item.isdefault = true;
        let countLIst_S = JSON.parse(localStorage.getItem("countLIst_S"));
        countLIst_S.isdefault = true;
        localStorage.setItem("countLIst_S", JSON.stringify(countLIst_S));
      } else if (num == 2 && type == "loca") {
        item.isdefault = true;
        let countLIst_T = JSON.parse(localStorage.getItem("countLIst_T"));
        countLIst_T.isdefault = true;
        localStorage.setItem("countLIst_T", JSON.stringify(countLIst_T));
      } else if (num == 3 && type == "loca") {
        item.isdefault = true;
        let sendFeeForAir = JSON.parse(localStorage.getItem("sendFeeForAir"));
        sendFeeForAir.isdefault = true;
        localStorage.setItem("sendFeeForAir", JSON.stringify(sendFeeForAir));
      }
    },
    onSubmit() {
      console.log(this.changeNum);
      let that = this;
      //changeNum //1 发货 2提货3收货
      if (!this.fromPop.name) return this.$message("请输入联系人姓名");
      if (!this.fromPop.tel) return this.$message("请输入联系人电话");
      if (this.changeNum == 1) {
        //新增发货
        let params = {
          customerid: JSON.parse(localStorage.getItem("Authorization"))
            .customerid, //客户id
          id: this.itemid,
          isdefault: this.fromPop.isdefault,
          name: this.fromPop.name,
          tag: "",
          tel: this.fromPop.tel,
        };
        this.axios.post(`/customer/addOrUpdateShipper`, params).then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.$message({ message: "成功", type: "success" });
            if (this.countLIst_S.id == this.itemid) {
              //为了更新本地默认通讯录信息
              this.countLIst_S = params;
              localStorage.setItem("countLIst_S", JSON.stringify(params));
            }
            this.getFadata();
            this.dialogTableVisible = false;
          } else {
            this.$message(res.data.message);
          }
        });
      } else if (this.changeNum == 2) {
        if (this.ssqnames.length == 0) return this.$message("请选择联系地址");
        if (!this.fromPop.address) return this.$message("请输入详细地址");
        let params = {
          customerid: JSON.parse(localStorage.getItem("Authorization"))
            .customerid, //客户id
          id: this.itemid,
          isdefault: this.fromPop.isdefault,
          name: this.fromPop.name,
          tag: "",
          tel: this.fromPop.tel,
          parvince: this.ssqnames[0],
          city: this.ssqnames[1],
          area: this.ssqnames[2],
          address: this.fromPop.address,
        };
        this.axios.post(`/customer/addOrUpdateDelivery`, params).then((res) => {
          if (res.data.code == "200") {
            this.$message({ message: "成功", type: "success" });
            this.getTidata();
            this.dialogTableVisible = false;
          } else {
            this.$message(res.data.message);
          }
        });
      } else {
        //新增或修改收货人
        if (this.ssqnames.length == 0) return this.$message("请选择联系地址");
        if (!this.fromPop.address) return this.$message("请输入详细地址");
        let params = {
          customerid: JSON.parse(localStorage.getItem("Authorization"))
            .customerid, //客户id
          id: this.itemid,
          isdefault: this.fromPop.isdefault,
          name: this.fromPop.name,
          tag: "",
          tel: this.fromPop.tel,
          country: this.ssqnames[0],
          city: this.ssqnames[1],
          area: this.ssqnames[2],
          address: this.fromPop.address,
          //为了保存到本地赋值
          countryId: this.fromPop.countryId,
          cityId: this.fromPop.cityId,
          areaId: this.fromPop.areaId,
        };
        this.axios
          .post(`/customer/addOrUpdateConsigner`, params)
          .then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.$message({ message: "成功", type: "success" });
              if (this.sendFeeForAir.id == this.itemid) {
                //为了更新本地默认通讯录信息
                this.sendFeeForAir = params;
                localStorage.setItem("sendFeeForAir", JSON.stringify(params));
              }
              this.getSHdata();
              this.dialogTableVisible = false;
            } else {
              this.$message(res.data.message);
            }
          });
      }
    },
    changeFAitem(item) {
      this.showFa = false;
      this.countLIst_S = item;
      localStorage.setItem("countLIst_S", JSON.stringify(item));
    },
    changeTiitem(item) {
      console.log(item);
      this.showTi = false;
      this.countLIst_T = item;
      localStorage.setItem("countLIst_T", JSON.stringify(item));
    },
    changeShitem(item) {
      console.log(item);
      this.sendFeeForAir = Object.assign(this.sendFeeForAir, item);
      this.showReceive = false;

      localStorage.setItem("sendFeeForAir", JSON.stringify(this.sendFeeForAir));

      // this.getPSFcount(); //重新计算配送费
    },
    UpItem(num, item) {
      console.log(num);
      this.itemid = item.id;
      this.getProvinces(num);
      this.ssqnames = [];
      this.changeNum = num;
      this.dialogTableVisible = true;
      this.fromPop = JSON.parse(JSON.stringify(item));
      // console.log(this.fromPop);
      if (num == 2) {
        this.ssqnames[0] = item.parvince;
        this.ssqnames[1] = item.city;
        this.ssqnames[2] = item.area;
      } else if (num == 3) {
        this.ssqnames[0] = item.country;
        this.ssqnames[1] = item.city;
        this.ssqnames[2] = item.area;
      }
    },
    addNewpop(num) {
      this.itemid = "";
      this.changeNum = num;
      this.fromPop.name = "";
      this.fromPop.tel = "";
      this.ssqnames = [];
      this.fromPop.address = "";
      this.dialogTableVisible = true;
      if (num != "1") {
        //1是发货人 没有省市区
        this.getProvinces(num); //查询省市区
      }
    },
    getProvinces(num) {
      //获取省市区和国外地址
      let url = "";
      let that = this;
      if (num == 3) {
        //国外城市和区域 2是国外 3是国内
        url = "/filedata/findThirdLevelAddress";
        this.axios
          .post(url)
          .then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.citylist = res.data.datas;
            } else {
            }
          })
          .catch((res) => {
            console.log(res);
          });
      } else {
        //国内省市区
        url = "/filedata/filedataProvinces";
        this.axios
          .post(url)
          .then((res) => {
            console.log(res);
            if (res.data.code == "200") {
              this.Guojialist = res.data.datas;
            } else {
            }
          })
          .catch((res) => {
            console.log(res);
          });
      }
    },
    changessq(e) {
      //省市区
      console.log(this.ssqnames);
    },
    pathToback() {
      this.$router.go(-1);
    },
    pathToNext() {
      if (!this.pickFeeForAir.checked && !this.inwarehousetime)
        return this.$message({
          showClose: true,
          message: "请选择入仓时间",
        });
      localStorage.setItem("inwarehousetime", this.inwarehousetime);
      if (this.sendFeeForAir.name == "")
        return this.$message({
          showClose: true,
          message: "请选择或添加发货信息",
        });
      let params = {};
      let that = this;
      params = {
        recgoodsCountry: this.sendFeeForAir.country,
        toWarehouseId: this.description.id,
      };
      this.axios
        .post(
          `/busLcljobsBefore/validateWarehouseCountry`,
          qs.stringify(params)
        )
        .then((res) => {
          if (res.data.code == "200") {
            localStorage.setItem("remarksForAir", JSON.stringify(this.remarks));
            this.$router.push({
              name: "AirConfirmPage",
            });
          } else {
            this.$alert(res.data.message, "错误", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$message({
                  type: "info",
                  message: `请重新选择送货上门地址`,
                });
              },
            });
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });
    },

    getFadata() {
      //发货人
      let that = this;
      let customerId = JSON.parse(localStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .get(`/customer/addressListForShipper/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.FapopList = res.data.datas;
            if (localStorage.getItem("countLIst_S")) {
              //如果有选择收货费
              this.countLIst_S = JSON.parse(
                localStorage.getItem("countLIst_S")
              );
            } else {
              // 本地没有就循环数据索取默认
              res.data.datas.forEach((item) => {
                if (item.isdefault) {
                  this.countLIst_S = item;
                }
              });
              localStorage.setItem(
                "countLIst_S",
                JSON.stringify(this.countLIst_S)
              );
            }
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getTidata() {
      //提货人
      let that = this;
      let customerId = JSON.parse(localStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .get(`/customer/addressListForDelivery/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.TipopList = res.data.datas;
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getSHdata() {
      //收货人
      let that = this;
      let customerId = JSON.parse(localStorage.getItem("Authorization"))
        .customerid;
      this.axios
        .get(`/customer/addressListForConsigner/${customerId}`)
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            this.SHpopList = res.data.datas;
            if (localStorage.getItem("sendFeeForAir")) {
              //如果有选择收货费
              this.sendFeeForAir = JSON.parse(
                localStorage.getItem("sendFeeForAir")
              );
            } else {
              //如果没有选择就显示默认
              res.data.datas.forEach((item) => {
                if (item.isdefault) {
                  this.sendFeeForAir = Object.assign(this.sendFeeForAir, item);
                }
              });
              localStorage.setItem(
                "sendFeeForAir",
                JSON.stringify(this.sendFeeForAir)
              );
            }
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },

    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 150) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
  },
  created() {
    this.cangkuitem = JSON.parse(localStorage.getItem("cangkuitem"));

    // jack
    if (localStorage.getItem("transportFeeForAir")) {
      //运输费
      this.transportFeeForAir = JSON.parse(
        localStorage.getItem("transportFeeForAir")
      );
    }
    if (localStorage.getItem("sendFeeForAir")) {
      this.sendFeeForAir = JSON.parse(localStorage.getItem("sendFeeForAir"));
    }
    if (localStorage.getItem("pickFeeForAir")) {
      this.pickFeeForAir = JSON.parse(localStorage.getItem("pickFeeForAir"));
    }
    if (localStorage.getItem("inwarehousetime")) {
      this.inwarehousetime = localStorage.getItem("inwarehousetime")
    }
    if (localStorage.getItem("moreFeeListForAir")) {
      this.feeList = JSON.parse(
        localStorage.getItem("moreFeeListForAir")
      ).feeItemDTOS;
      this.allMoreFeeInfo = JSON.parse(
        localStorage.getItem("moreFeeListForAir")
      );
    }
  },
  mounted() {
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
    this.getFadata();
    this.getTidata();
    this.getSHdata();
  },
};
</script>
<style scoped>
.fontString {
  font-weight: bold;
}
.count {
  width: 100%;
  padding-top: 30px;
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.wrap_count {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.header_logo {
  width: 100%;
  float: left;
  text-align: left;
}
.morentype {
  width: 80px;
  height: 23px;
  background: #dedede;
  border-radius: 5px;
  color: #9a9a9a;
  padding: 2px;
  box-sizing: border-box;
  text-align: center;
}
.overText {
  width: 210px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.poperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #e6e6e6;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.4s;
}
.poperWrap:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
}
.thatpoperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #604aff;
  background: #dfdbff;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.lianxiren {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tittype {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 778px;
}
/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.popWrap_l {
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-flow: row nowrap;
  justify-content: space-between;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* flex-direction: column; */
}
.Item_Right {
  float: left;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.center_wrap {
  width: 1098px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 24px 28px 12px 28px;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  margin-bottom: 15px;
  overflow: hidden;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  float: left;
  width: 764px;
  background: #ffffff;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.wrap_R {
  float: right;
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
/* table 滚动条 */
.OrderDetails {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
}
.OrderDetails::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/airOrder/AirConsignment.vue